module.exports = __webpack_public_path__ + "img/gzh.3eb0adf9.png";